import React, { useState } from 'react';
import './AccessControlModal.css';

const AccessControlModal = ({ buttonName, onSuccess, onCancel }) => {
  const [accessCode, setAccessCode] = useState('');
  const [accessCodes] = useState({
    temple: '.<-.<-',
    brain: 'PTTPLNRTT',
    matrix: '1628',
    wellbeing: 'helpme'
  });

  const getButtonDisplayName = (name) => {
    const names = {
      temple: 'Pre Layout Artefact',
      brain: 'Cognitive Mapping',
      matrix: 'Our Partners',
      wellbeing: 'Safeguarding'
    };
    return names[name] || 'This Area';
  };

  const handleSubmit = () => {
    let isValid = false;
    
    switch(buttonName) {
      case 'temple':
        isValid = accessCode === accessCodes.temple;
        break;
      case 'brain':
        isValid = accessCode === accessCodes.brain;
        break;
      case 'matrix':
        isValid = accessCode === accessCodes.matrix;
        break;
      case 'wellbeing':
        isValid = accessCode === accessCodes.wellbeing;
        break;
      default:
        isValid = false;
    }

    if (isValid) {
      onSuccess();
    } else {
      alert('Invalid access code!');
      setAccessCode('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Access Required</h2>
        <p>Please enter the access code for <strong>{getButtonDisplayName(buttonName)}</strong>:</p>
        <input
          type="password"
          id="accessCode"
          name="accessCode"
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter access code"
          className="code-input"
          autoFocus
        />
        <div className="modal-buttons">
          <button onClick={handleSubmit}>Submit</button>
          <button onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AccessControlModal;